<template lang="pug">

	#projectPresentation
		.project-presentation(:class="{ 'active' : active }")
			.close-presentation(@click="togglePresentation()")
				include ../../../pug/partials/icon-close.pug
			.presentation-image(
				:class="{ 'active' : !loading }"
				v-if="!loading"
			)
				img(:src="'/img' + images[currentImage].url + '?w=2400&fit=crop'")
				.image-footer
					.project-title {{ projectTitle }}
					.image-controls
						.image-caption(v-html="images[currentImage].alt")
						.image-counter
							span.current(v-text="currentImage + 1")
							span.separator(v-text="' / '")
							span.total(v-text="images.length")
						.image-nav
							span.cursor-pointer(@click="currentImage = currentImage - 1" v-if="currentImage > 0") Prev
							span.opacity-50(v-else) Prev
							span.cursor-pointer(@click="currentImage = currentImage + 1" v-if="currentImage + 1 < images.length") Next
							span.opacity-50(v-else) Next
					
			.image-loading
				i.fal.fa-spinner.fa-spin.text-2xl(:class="{ 'active' : !loading }")

</template>

<script>
const axios = require('axios');
import PresentationQuery from '../graphql/presentation.graphql';
import { print } from 'graphql/language/printer';
let PresentationQueryString = print(PresentationQuery);

export default {
	el: "presentation",
	name: "Presentation",
	data() {
		return {
			active: false,
			loading: true,
			projectTitle: '',
			currentImage: 0,
			images: null,
			errors: false
		}
	},
	methods: {
		getPresentation(productId) {
			return axios({
				url: '/graphql',
				method: 'post',
				data: {
					query: PresentationQueryString,
					variables: {
						id: productId
					}
				}
			})
		},
		togglePresentation() {
			this.active = !this.active;
			// window.dispatchEvent(new CustomEvent('toggleoverlay'))
		},
		nextImage(direction) {
			this.currentImage = this.currentImage + 1;
			if (this.currentImage >= this.images.length) {
				this.currentImage = 0;
			}
		},
	},
	watch: {
		active: {
			handler: function(val) {
				if (val) {
					document.body.classList.add('overflow-hidden')
				} else {
					document.body.classList.remove('overflow-hidden')
				}
			}
		}
	},
	beforeMount() {
		const productId = this.$el.dataset.productid
		this.getPresentation(productId)
			.then((response) => {

				if (response.data.errors) {
					this.errors = response.data.errors
				}

				let imgs = []

				let hero = {}
				// hero.alt = response.data.data.entry.hero_image.alt
				hero.url = response.data.data.entry.hero_image.url
				imgs.push(hero)

				this.projectTitle = response.data.data.entry.title

				response.data.data.entry.sections.forEach(section => {
					section.blocks.forEach(block => {
						if (block.type === 'slideshow') {
							block.images.forEach(image => {
								let img = {}
								img.alt = image.alt
								img.url = image.url
								imgs.push(img)
							})
						}
					})
				})

				this.images = imgs

				this.loading = false

			})
			.catch((error) => {
				console.log(error);
			})
			.then(() => {
				console.log('Presentation loaded');
			});
	},
	mounted() {
		window.addEventListener('openpresentation', () => {
			console.log('event openpresentation')
			this.togglePresentation()
		})
	}
}
</script>
